import { useHandleChoice } from "../../../hooks/useHandleChoice";
import "./ArticleRating.scss";

interface Props {
  articleId: string;
  articleName: string;
}

const ArticleRating = ({ articleId, articleName }: Props) => {
  const { choices, selectedChoice, handleChoice } = useHandleChoice(articleId);

  return (
    <div className="m-rating-article">
      <div
        className={`rating-content ${
          selectedChoice.name ? "rating-content--open" : ""
        }`}
      >
        <div
          className={`rating-box ${
            selectedChoice.name ? "rating-box--open" : ""
          }`}
        >
          <p
            tabIndex={-1}
            className={`rating-title ${
              selectedChoice.name ? "rating-title--open" : ""
            }`}
          >
            ¿Te resultó útil este contenido?
          </p>
          <div className="choices">
            {choices.map(({ name, value }) => (
              <div
                key={name}
                className={`choices__item ${
                  value
                    ? `gtmArticuloLike${articleName?.replace(/ /g, "")}`
                    : `gtmArticulodislike${articleName?.replace(/ /g, "")}`
                }`}
              >
                <button
                  className={`${
                    value
                      ? `choices__item--like gtmArticuloLike${articleName?.replace(
                          / /g,
                          ""
                        )}`
                      : `gtmArticulodislike${articleName?.replace(/ /g, "")}`
                  } ${selectedChoice.value === value ? "selected-choice" : ""}`}
                  onClick={() => handleChoice(value)}
                  aria-label={`Responder con un ${name}`}
                >
                  <LikeIcon isActive={selectedChoice.name} />
                </button>
                <small>{name}</small>
              </div>
            ))}
          </div>
        </div>
        <p
          className={`rated-message ${selectedChoice.name ? "open" : "closed"}`}
        >
          ¡Gracias por tu respuesta!
        </p>
      </div>
    </div>
  );
};

export default ArticleRating;

const LikeIcon = ({ isActive }: { isActive: boolean }) => {
  return (
    <svg
      width="33"
      height="37"
      viewBox="0 0 33 37"
      xmlns="http://www.w3.org/2000/svg"
      className={`like_icon ${isActive ? "active" : ""}`}
    >
      <defs>
        <mask id="circle-mask">
          <circle
            cx="15"
            cy="15"
            r="0"
            className={`circle ${isActive ? "expand" : ""}`}
            fill="red"
          />
        </mask>
      </defs>

      <path
        stroke="none"
        fill="none"
        d="M 16.711 2.044 C 13.41 2.873 13.954 7.344 13.341 8.483 C 11.22 12.425 6.966 15.115 6.811 15.58 C 6.338 17 7.11 32.212 8.506 34.187 C 9.392 35.44 17.329 35.541 23.166 33.721 C 25.092 33.12 26.105 32.1 27.383 30.619 C 29.72 27.908 29.878 24.556 30.595 21.285 C 30.88 19.987 30.917 16.62 29.66 15.987 C 28.491 15.398 19.824 16.162 18.496 15.285 C 17.945 14.922 19.059 9.179 19.17 8.397 C 19.524 5.917 20.025 3.574 17.61 2.346 C 17.143 2.108 17.171 2.105 16.665 2.105"
        mask="url(#circle-mask)"
      />

      <path
        fill="black"
        stroke="black"
        className="border_like"
        d="M1.35547 15.7715L2.59595 15.6642C2.53851 14.9999 1.96795 14.4988 1.3018 14.5275C0.635625 14.5563 0.110352 15.1047 0.110352 15.7715H1.35547ZM29.9701 18.7983L28.7988 25.5712L31.2527 25.9957L32.424 19.2226L29.9701 18.7983ZM18.3638 34.0594H10.6463V36.5497H18.3638V34.0594ZM9.13327 32.6691L7.78495 17.0757L5.30398 17.2902L6.6523 32.8835L9.13327 32.6691ZM28.7988 25.5712C27.9575 30.4365 23.5705 34.0594 18.3638 34.0594V36.5497C24.7159 36.5497 30.1937 32.1187 31.2527 25.9957L28.7988 25.5712ZM18.38 7.24816L17.2799 13.9628L19.7374 14.3654L20.8376 7.65082L18.38 7.24816ZM8.30775 15.7904L10.6963 13.7322L9.0707 11.8458L6.68216 13.904L8.30775 15.7904ZM15.0418 7.03552L15.8315 3.99104L13.4212 3.36576L12.6314 6.41023L15.0418 7.03552ZM17.0244 3.39371L17.2651 3.47103L18.0268 1.10014L17.786 1.02283L17.0244 3.39371ZM13.8457 10.0967C14.3635 9.12718 14.7657 8.10022 15.0418 7.03552L12.6314 6.41023C12.405 7.2829 12.0751 8.12602 11.6491 8.92341L13.8457 10.0967ZM17.2651 3.47103C17.7738 3.63445 18.135 4.02736 18.2537 4.48515L20.6642 3.85989C20.3231 2.54501 19.3167 1.51453 18.0268 1.10014L17.2651 3.47103ZM15.8315 3.99104C15.8898 3.7669 16.0517 3.56092 16.2965 3.4429L15.2154 1.19955C14.3322 1.62512 13.6688 2.41067 13.4212 3.36576L15.8315 3.99104ZM16.2965 3.4429C16.5202 3.33511 16.7835 3.31635 17.0244 3.39371L17.786 1.02283C16.9399 0.750978 16.0166 0.813483 15.2154 1.19955L16.2965 3.4429ZM19.8724 17.0166H28.4738V14.5264H19.8724V17.0166ZM4.20896 34.3186L2.59595 15.6642L0.114983 15.8787L1.72799 34.5331L4.20896 34.3186ZM2.60059 34.4956V15.7715H0.110352V34.4956H2.60059ZM1.72799 34.5331C1.70609 34.2799 1.90574 34.0594 2.16348 34.0594V36.5497C3.36871 36.5497 4.31257 35.5169 4.20896 34.3186L1.72799 34.5331ZM20.8376 7.65082C21.0443 6.38888 20.9853 5.09765 20.6642 3.85989L18.2537 4.48515C18.4878 5.38726 18.5308 6.32839 18.38 7.24816L20.8376 7.65082ZM10.6463 34.0594C9.85952 34.0594 9.20138 33.4568 9.13327 32.6691L6.6523 32.8835C6.83153 34.9563 8.56503 36.5497 10.6463 36.5497V34.0594ZM10.6963 13.7322C11.8249 12.7596 13.0416 11.602 13.8457 10.0967L11.6491 8.92341C11.0741 9.99991 10.1584 10.9084 9.0707 11.8458L10.6963 13.7322ZM32.424 19.2226C32.8478 16.7714 30.9629 14.5264 28.4738 14.5264V17.0166C29.4144 17.0166 30.1313 17.8661 29.9701 18.7983L32.424 19.2226ZM2.16348 34.0594C2.40621 34.0594 2.60059 34.256 2.60059 34.4956H0.110352C0.110352 35.6288 1.02824 36.5497 2.16348 36.5497V34.0594ZM17.2799 13.9628C17.018 15.5613 18.2502 17.0166 19.8724 17.0166V14.5264C19.7895 14.5264 19.7233 14.4514 19.7374 14.3654L17.2799 13.9628ZM7.78495 17.0757C7.74275 16.5876 7.93757 16.1095 8.30775 15.7904L6.68216 13.904C5.70544 14.7457 5.1929 16.0057 5.30398 17.2902L7.78495 17.0757Z"
      />
    </svg>
  );
};
